var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "16px",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2A7188BB-AE77-477F-B1BB-99BEFD540C8E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Message-Center--New-Message",
    transform: "translate(-501.000000, -80.000000)",
    fill: "#595959",
    fillRule: "nonzero",
    stroke: "#595959",
    strokeWidth: 0.35
  }, /*#__PURE__*/React.createElement("g", {
    id: "edit-(1)",
    transform: "translate(501.800163, 80.590812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9143422,9.41334854 C13.7069566,9.41334854 13.5388775,9.5814277 13.5388775,9.78881329 L13.5388775,13.1225296 C13.5381441,13.7443931 13.0343467,14.2483372 12.4124832,14.2489238 L1.87732374,14.2489238 C1.25546025,14.2483372 0.751662816,13.7443931 0.750929496,13.1225296 L0.750929496,3.3382996 C0.751662816,2.71658276 1.25546025,2.21263867 1.87732374,2.21190535 L5.21104002,2.21190535 C5.41842564,2.21190535 5.58650477,2.04382619 5.58650477,1.8364406 C5.58650477,1.62920167 5.41842564,1.46097586 5.21104002,1.46097586 L1.87732374,1.46097586 C0.840982388,1.46214918 0.00117332734,2.30195821 0,3.3382996 L0,13.1226763 C0.00117332734,14.1590176 0.840982388,14.9988267 1.87732374,15 L12.4124832,15 C13.4488246,14.9988267 14.2886337,14.1590176 14.289807,13.1226763 L14.289807,9.78881329 C14.289807,9.5814277 14.1217278,9.41334854 13.9143422,9.41334854 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.1410877,0.49488745 C13.4812378,-0.164962483 12.4114566,-0.164962483 11.7516066,0.49488745 L5.05308083,7.19341322 C5.00717441,7.23931964 4.9740279,7.29622605 4.95672134,7.35870572 L4.07584586,10.5388628 C4.03961937,10.6692488 4.07643248,10.8088748 4.1720587,10.9046476 C4.26783153,11.0002738 4.40745749,11.0370869 4.53784348,11.0010071 L7.71800057,10.1199849 C7.78048023,10.1026784 7.83738661,10.0695319 7.88329307,10.0236254 L14.5816721,3.32495299 C15.2404954,2.66466305 15.2404954,1.59576184 14.5816721,0.935471865 L14.1410877,0.49488745 Z M5.87118334,7.4374653 L11.3534086,1.95509332 L13.1214663,3.72315096 L7.63909429,9.20552295 L5.87118334,7.4374653 Z M5.51801181,8.14615502 L6.93055127,9.55884113 L4.9766679,10.100185 L5.51801181,8.14615502 Z M14.0507415,2.79402237 L13.6525436,3.19222034 L11.8843393,1.42401604 L12.2826839,1.02581807 C12.649202,0.659299934 13.2434923,0.659299934 13.6100104,1.02581807 L14.0507415,1.46640249 C14.416673,1.83336063 14.416673,2.42721092 14.0507415,2.79402237 L14.0507415,2.79402237 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.7e6a860ef81728e016db8a3b0c42ea09.svg";
export { ForwardRef as ReactComponent };